module.exports = __webpack_public_path__ + "static/media/autokar3 (2).a7106f4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (2).jpg
// module id = 859
// module chunks = 0